import React, { useState, useEffect } from 'react';

// --- ICONS ---
const IconTrash = () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>;
const IconEye = () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>;
const IconBriefcase = () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>;

export default function AdminJobManager() {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedJob, setSelectedJob] = useState(null); // Để hiện Modal xem chi tiết
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    const fetchJobs = async () => {
        const token = localStorage.getItem('skillmatch_token');
        try {
            // ✅ Sửa đường dẫn từ /api/jobs thành /api/admin/jobs
            const res = await fetch(`${apiBaseUrl}/api/admin/jobs`, {
                headers: { 'x-auth-token': token }
            });
            const data = await res.json();
            if (res.ok) {
                setJobs(data);
            } else {
                console.error("Lỗi:", data.message);
            }
        } catch (error) {
            console.error("Lỗi lấy danh sách Job:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchJobs(); }, []);

    const handleDeleteJob = async (id, title) => {
        if (!window.confirm(`Xóa vĩnh viễn tin: ${title}?`)) return;
        const token = localStorage.getItem('skillmatch_token');
        try {
            const res = await fetch(`${apiBaseUrl}/api/admin/jobs/${id}`, {
                method: 'DELETE',
                headers: { 'x-auth-token': token }
            });
            if (res.ok) {
                setJobs(jobs.filter(j => j._id !== id));
                if (selectedJob?._id === id) setSelectedJob(null);
            }
        } catch (error) { alert("Lỗi xóa"); }
    };

    const filteredJobs = jobs.filter(j =>
        j.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (j.createdBy?.profile?.companyName || j.companyName)?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between items-center mb-8">
                    <h1 className="text-2xl font-bold text-gray-900">Quản lý Tin tuyển dụng</h1>
                    <input
                        type="text"
                        placeholder="Tìm vị trí hoặc công ty..."
                        className="pl-4 pr-4 py-2 border rounded-xl w-80 outline-none focus:ring-2 focus:ring-indigo-500"
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                    <table className="w-full text-left">
                        <thead className="bg-gray-50 border-b border-gray-200">
                            <tr>
                                <th className="p-4 text-xs font-bold text-gray-500 uppercase">Tin tuyển dụng</th>
                                <th className="p-4 text-xs font-bold text-gray-500 uppercase">Doanh nghiệp</th>
                                <th className="p-4 text-xs font-bold text-gray-500 uppercase">Lương / Loại</th>
                                <th className="p-4 text-xs font-bold text-gray-500 uppercase">Trạng thái</th>
                                <th className="p-4 text-xs font-bold text-gray-500 uppercase text-right">Hành động</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {filteredJobs.map((job) => (
                                <tr key={job._id} className="hover:bg-gray-50 transition-colors">
                                    <td className="p-4">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center font-bold">
                                                {job.title?.charAt(0)}
                                            </div>
                                            <span className="font-bold text-gray-900">{job.title}</span>
                                        </div>
                                    </td>
                                    <td className="p-4">
                                        <div className="font-medium text-gray-800">
                                            {/* Ưu tiên lấy từ User Profile, nếu không có thì lấy companyName tĩnh của Job */}
                                            {job.createdBy?.profile?.companyName || job.companyName || "Chưa cập nhật"}
                                        </div>
                                        <div className="text-xs text-gray-500">{job.createdBy?.email}</div>
                                    </td>
                                    <td className="p-4 text-sm">
                                        <div className="text-green-600 font-bold">{job.salary}</div>
                                        <div className="text-gray-500">{job.type}</div>
                                    </td>
                                    <td className="p-4">
                                        <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${job.status === 'Đang tuyển' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                                            }`}>
                                            {job.status}
                                        </span>
                                    </td>
                                    <td className="p-4 text-right">
                                        <div className="flex justify-end gap-2">
                                            {/* Thay đổi từ Xem ngoài web thành Xem detail ngay tại Admin */}
                                            <button
                                                onClick={() => setSelectedJob(job)}
                                                className="p-2 text-gray-400 hover:bg-indigo-50 hover:text-indigo-600 rounded-lg"
                                                title="Xem chi tiết"
                                            >
                                                <IconEye />
                                            </button>
                                            <button
                                                onClick={() => handleDeleteJob(job._id, job.title)}
                                                className="p-2 text-gray-400 hover:bg-red-50 hover:text-red-600 rounded-lg"
                                            >
                                                <IconTrash />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* --- MODAL XEM CHI TIẾT (Tránh lỗi thoát trang Admin) --- */}
            // Cập nhật lại phần Render Modal trong AdminJobManager.jsx
{selectedJob && (
    <div className="fixed inset-0 bg-black/75 z-[10000] flex items-center justify-center p-4">
        {/* ✅ ĐÃ LOẠI BỎ backdrop-blur-sm VÀ THAY BẰNG bg-black/75 ĐỂ TĂNG HIỆU SUẤT */}
        <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl flex flex-col max-h-[90vh] animate-modalSlide">
            <div className="p-6 border-b flex justify-between items-center bg-gray-50 rounded-t-2xl">
                <h2 className="text-xl font-bold text-gray-800">Chi tiết tin tuyển dụng</h2>
                <button onClick={() => setSelectedJob(null)} className="text-gray-400 hover:text-gray-900 text-2xl transition-colors">&times;</button>
            </div>

            <div className="p-8 overflow-y-auto">
                <div className="mb-6">
                    <h3 className="text-2xl font-black text-indigo-600 mb-1">{selectedJob.title}</h3>
                    <p className="text-gray-700 font-bold">
                        {/* ✅ Tự động hiển thị tên doanh nghiệp nếu đã được populate */}
                        {selectedJob.createdBy?.profile?.companyName || selectedJob.companyName || "Chưa cập nhật"}
                    </p>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
                        <p className="text-xs text-gray-400 uppercase font-black">Mức lương</p>
                        <p className="font-bold text-gray-700">{selectedJob.salary}</p>
                    </div>
                    <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
                        <p className="text-xs text-gray-400 uppercase font-black">Địa điểm</p>
                        <p className="font-bold text-gray-700">{selectedJob.location}</p>
                    </div>
                </div>

                <div className="space-y-6">
                    <div>
                        <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                            <div className="w-1.5 h-4 bg-indigo-500 rounded-full"></div> Mô tả công việc
                        </h4>
                        <div className="text-gray-600 text-sm space-y-2 pl-3">
                            {selectedJob.description?.map((line, idx) => <p key={idx}>• {line}</p>)}
                        </div>
                    </div>

                    <div>
                        <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                            <div className="w-1.5 h-4 bg-indigo-500 rounded-full"></div> Yêu cầu ứng viên
                        </h4>
                        <div className="text-gray-600 text-sm space-y-2 pl-3">
                            {selectedJob.requirements?.map((line, idx) => <p key={idx}>• {line}</p>)}
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-6 border-t bg-gray-50 flex justify-end gap-3 rounded-b-2xl">
                <button onClick={() => setSelectedJob(null)} className="px-6 py-2.5 bg-white border border-gray-200 rounded-xl font-bold text-gray-600 hover:bg-gray-100 transition-all">Đóng</button>
                <button onClick={() => handleDeleteJob(selectedJob._id, selectedJob.title)} className="px-6 py-2.5 bg-red-600 text-white rounded-xl font-bold hover:bg-red-700 shadow-lg shadow-red-200 transition-all">Xóa tin này</button>
            </div>
        </div>
    </div>
)}

<style>{`
    /* ✅ Animation đơn giản hóa để chạy mượt hơn trên máy cấu hình yếu */
    @keyframes modalSlide { 
        from { opacity: 0; transform: translateY(10px); } 
        to { opacity: 1; transform: translateY(0); } 
    }
    .animate-modalSlide { animation: modalSlide 0.2s ease-out; }
`}</style>
        </div>
    );
}